// extracted by mini-css-extract-plugin
export default {"image-config-panel__message":"imageConfigPanel_image-config-panel__message__NCpYd"};